import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const { DISABLE_AUTO_MATCH_FAILURE, DISABLE_AUTO_MATCH_REQUEST, DISABLE_AUTO_MATCH_SUCCESS } =
  TherapistAction;

function* disableAutoMatch(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistService.disableAutoMatchSerivce, action.payload);
    if (response?.status === 200) {
      yield put({
        type: DISABLE_AUTO_MATCH_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: DISABLE_AUTO_MATCH_FAILURE, payload: error });
  }
}

function* disableAutoMatchSaga() {
  yield takeEvery(DISABLE_AUTO_MATCH_REQUEST, disableAutoMatch);
}

export default disableAutoMatchSaga;
